import { Injectable } from '@angular/core';
import { OmniGeralRestService } from '../../../omni-rest/omni-geral/omni-geral-rest.service';

@Injectable()
export class OperacoesGeralService {
  constructor(private restService: OmniGeralRestService) {}

  tiposProdutos(agentId: number, tipoCliente?: number) {
    const url = tipoCliente
      ? `operacoes/tipos-produto/agentes/${agentId}?tipoCliente=${tipoCliente}`
      : `operacoes/tipos-produto/agentes/${agentId}`;
    return this.restService.get(url);
  }

  tiposProdutosNoAgent(tipoCliente?: number) {
    const url = tipoCliente
      ? `operacoes/tipos-produto?tipoCliente=${tipoCliente}`
      : 'operacoes/tipos-produto';
    return this.restService.get(url);
  }

  produtosPorUsuario(tipoOperacao) {
    return this.restService.get(
      `operacoes/produtos-por-usuario/${tipoOperacao}`
    );
  }
}
